import { useEffect, useState } from 'react'

import { ScrollList, Text } from '@hhgtech/hhg-components'
import Skeleton from 'react-loading-skeleton'

import { callApiNew } from 'api/axios'
import {
  formatDefaultCarousel,
  formatStatisticCarousel,
} from 'api/dataTransform'
import { PATHS } from 'api/paths'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { DefaultCarousel, StatisticCarousel } from 'interfaces/types'

import {
  StyledBottomInfo,
  StyledCardItem,
  StyledEmbedCarousel,
  StyledLeftInfo,
  StyledLegendContainer,
  StyledMidInfo,
  StyledPostContent,
  StyledStatisticCardItem,
} from './index.styled'

export type Props = {
  isMobile?: boolean
  columns?: number
  id: number
}

const HealthConcern = ({ isMobile, id }: Props) => {
  const [defaultData, setDefaultData] = useState<DefaultCarousel[]>([])
  const [statisticData, setStatisticData] = useState<StatisticCarousel[]>([])
  const [isTypeDefault, setIsTypeDefault] = useState<boolean>()
  const currentUrl = useCurrentUrl()
  useEffect(() => {
    const fetchData = async () => {
      const carouselResponse = await callApiNew(PATHS.COMMON.GET_CAROUSEL, {
        params: {
          id,
        },
      })
      if (carouselResponse?.data?.fields) {
        if (carouselResponse?.data?.fields?.type === 'default') {
          const carousels = carouselResponse?.data?.fields?.data?.map(
            formatDefaultCarousel,
          )
          setIsTypeDefault(true)
          setDefaultData(carousels)
        } else {
          const carousels = carouselResponse?.data?.fields?.data?.map(
            formatStatisticCarousel,
          )
          setIsTypeDefault(false)
          setStatisticData(carousels)
        }
      }
    }
    fetchData()
  }, [])

  const renderDefaultPartnerCard = (content: DefaultCarousel) => {
    return (
      <StyledCardItem>
        <StyledPostContent>
          <StyledLeftInfo className="post-title img-title img-mb">
            {!!content?.logoImage && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginBottom: '22px',
                }}
              >
                <img
                  src={content?.logoImage}
                  alt="avatar"
                  className="img-title img-mb"
                  loading="lazy"
                />
              </div>
            )}
            <div>
              <p
                className="banner-title"
                dangerouslySetInnerHTML={{ __html: content.title }}
              ></p>
              <p
                className="banner-description"
                dangerouslySetInnerHTML={{ __html: content.description }}
              ></p>
            </div>
          </StyledLeftInfo>
          <StyledMidInfo
            data-has-legend={
              typeof content.legends !== 'undefined' &&
              content.legends.length > 0
            }
          >
            {content?.mid?.map((midContent, index) => (
              <div className="img-container" key={index}>
                <div className="columns">
                  <img loading="lazy" src={midContent?.img} alt="avatar" />
                  <Text size="md" className="img-caption">
                    {midContent?.label}
                  </Text>
                </div>
              </div>
            ))}
          </StyledMidInfo>

          <StyledLegendContainer>
            {content?.legends?.map((legend, index) => (
              <StyledBottomInfo key={index}>
                {legend?.icon && (
                  <div className="flag">
                    <img loading="lazy" src={legend?.icon} alt="" />
                  </div>
                )}
                <span
                  className="legend-content"
                  dangerouslySetInnerHTML={{ __html: legend.label }}
                ></span>
              </StyledBottomInfo>
            ))}
          </StyledLegendContainer>
        </StyledPostContent>
      </StyledCardItem>
    )
  }

  const renderStatisticPartnerCard = (content: StatisticCarousel) => {
    return (
      <StyledStatisticCardItem>
        <img
          loading="lazy"
          src={
            isMobile && content.imageMobile
              ? content.imageMobile
              : content.imageDesktop
          }
          alt={content.title}
        />
      </StyledStatisticCardItem>
    )
  }

  return (
    <>
      {(defaultData?.length > 0 || statisticData?.length) > 0 ? (
        <StyledEmbedCarousel>
          {/* <StyledCarouselContainer
        data-custom-columns={typeof columns !== 'undefined'}
      /> */}
          <ScrollList
            column={1}
            row={1}
            isDotsShown={isMobile}
            mode="infinity"
            type="separated"
            arrowType="Care"
            isArrowShown={!isMobile}
            dataEventCategory="Carousel"
            dataEventAction="Click"
            dataEventLabel={currentUrl}
          >
            {isTypeDefault
              ? defaultData?.map((carousel: DefaultCarousel) =>
                  renderDefaultPartnerCard(carousel),
                )
              : statisticData?.map((carousel: StatisticCarousel) =>
                  renderStatisticPartnerCard(carousel),
                )}
          </ScrollList>
        </StyledEmbedCarousel>
      ) : (
        <StyledEmbedCarousel>
          <Skeleton height={isMobile ? 763 : 763} />
        </StyledEmbedCarousel>
      )}
    </>
  )
}

export { HealthConcern }
